export default __webpack_public_path__ + "assets/images/8c1c5c37d8a6328dbad56907cab3efe0.svg";